import { render } from "./columns.svg?vue&type=template&id=018339ef?inline"
const script = {}
script.render = render

export default script